import { registerPlugin } from '@capacitor/core';
import { istApp } from './platform.js';

/**
 * Der native Scan-Knopf.
 *
 * Existiert nur in der App. Im Browser gibt es weder ein Overlay über fremden
 * Apps noch Bildschirmaufnahme — dort bleibt die Dateiauswahl der Weg.
 */
const Plugin = registerPlugin('ScanOverlay');

export const scanOverlay = {
  verfuegbar: () => istApp(),

  /** Lokale Pokémon-Bilder aus früheren Scans. */
  async bilder() {
    if (!istApp()) {
      return { bilder: {} };
    }
    try {
      return await Plugin.bilder();
    } catch {
      return { bilder: {} };
    }
  },

  async zustand() {
    if (!istApp()) {
      return { moeglich: false, overlayErlaubt: false, laeuft: false };
    }
    try {
      return await Plugin.istMoeglich();
    } catch {
      return { moeglich: false, overlayErlaubt: false, laeuft: false };
    }
  },

  /** Öffnet die Systemeinstellung. Ein Dialog reicht dafür nicht. */
  overlayFreigeben: () => Plugin.overlayFreigeben(),

  /**
   * Fragt die Aufnahme-Bestätigung ab und startet den Knopf.
   *
   * Der Dienst läuft ausserhalb des Webviews und hat keine Sitzung — er
   * bekommt ein eigenes Token, das nur scannen darf.
   */
  starten: (token, basis) => Plugin.starten({ token, basis }),

  beenden: () => Plugin.beenden(),

  /**
   * Auf Aufnahmen hören.
   *
   * Das Bild kommt als Base64 — der Webview darf nicht beliebig auf das
   * Dateisystem zugreifen, und gebraucht wird es ohnehin nur einmal.
   */
  beiAufnahme(rueckruf) {
    if (!istApp()) {
      return { remove: () => {} };
    }
    return Plugin.addListener('aufnahme', rueckruf);
  },
};

/** Base64 in eine Datei verwandeln, die sich hochladen lässt. */
export function base64ZuDatei(base64, name = 'scan.png') {
  const rohe = atob(base64);
  const bytes = new Uint8Array(rohe.length);
  for (let i = 0; i < rohe.length; i++) {
    bytes[i] = rohe.charCodeAt(i);
  }
  return new File([bytes], name, { type: 'image/png' });
}
